import React from "react"
import { map } from "lodash"
import { Col, Input, Row } from "reactstrap"
import { useHistory, useLocation } from "react-router-dom"
import PropTypes from "prop-types"

const MyPagination = ({ totalPages, page, setPage }) => {
  const history = useHistory()
  const location = useLocation()

  const [pageNumber, setPageNumber] = React.useState(location?.state?.page ?? 1)

  const apiPage = () => {
    if (page >= totalPages.length) {
      return totalPages.length
    }
    if (page < 1) {
      return 1
    } else {
      return page
    }
  }
  const OnlyFive =
    totalPages.length > 5 && parseInt(page) > 5
      ? totalPages.slice(parseInt(page) - 5, parseInt(page) + 5)
      : totalPages.slice(0, parseInt(page) + 5)

  const [showOnlyFive, setShowOnlyFive] = React.useState(OnlyFive)

  React.useEffect(() => {
    if (OnlyFive?.length <= 10) {
      setShowOnlyFive(OnlyFive)
    }
  }, [page, location?.state?.page])

  const handleNextClick = () => {
    setPage(page + 1)

    const searchParams = new URLSearchParams(location.search)
    searchParams.set("p", page + 1)

    history.push({
      pathname: location.pathname,
      search: searchParams.toString(),
      state: {
        ...location.state,
        page: page + 1,
      },
    })
  }
  const handlePrevClick = () => {
    setPage(page - 1)

    const searchParams = new URLSearchParams(location.search)
    searchParams.set("p", page + 1)

    history.push({
      pathname: location.pathname,
      search: searchParams.toString(),
      state: {
        ...location.state,
        page: page + 1,
      },
    })
  }
  const handleNumClick = item => {
    setPage(item)
    const searchParams = new URLSearchParams(location.search)
    searchParams.set("p", item)

    history.push({
      pathname: location.pathname,
      search: searchParams.toString(),
      state: {
        ...location.state,
        page: item,
      },
    })
  }

  const handleSubmit = e => {
    e.preventDefault()
    setPage(pageNumber)

    const searchParams = new URLSearchParams(location.search)
    searchParams.set("p", pageNumber)

    history.push({
      pathname: location.pathname,
      search: searchParams.toString(),
      state: {
        ...location.state,
        page: pageNumber,
      },
    })
  }

  React.useEffect(() => {
    if (location?.state && location?.state?.page) {
      setPage(location?.state?.page)
    }
  }, [location?.state?.page])

  return (
    <Row
      className="align-items-md-center  mt-30 "
      style={{ marginTop: "2rem" }}
    >
      <Col
        style={{
          background: "#EFF5F5",
          padding: 12,
          borderRadius: 8,
        }}
        className="align-items-center inner-custom-pagination  d-flex pagination pagination-rounded justify-content-center mb-2 inner-custom-pagination"
      >
        <form
          onSubmit={handleSubmit}
          className="d-flex align-items-center"
          style={{ flex: 1 }}
        >
          <p className="p-0 m-0 pe-1 font-size-12">Page </p>
          <Input
            name="page"
            type="number"
            min={1}
            max={totalPages?.length}
            style={{ width: 45, height: 30, border: "1px solid #556ee6", borderRadius: "6px" }}
            value={pageNumber}
            onChange={e => setPageNumber(e.target.value)}
          // defaultValue={pageNumber}
          />
          <p className="p-0 m-0 px-1 font-size-12"> of {totalPages?.length}</p>
          <button
            type="submit"
            style={{
              width: 60,
              height: 30,
              backgroundColor: "#556ee6",
              border: "none",
              borderRadius: "6px",
              color: "#fff",
              fontWeight: "500",
            }}
            className={`ms-2 btn tickbtn d-flex align-items-center justify-content-center`}
          >
            Go
            <i className="fas fa-angle-right ms-1"></i>
          </button>
        </form>
        <div className="text-md-right overflowScroll">
          {page <= 1 ? (
            <></>
          ) : (
            <div
              className="btn-group me-0 "
              role="group"
              aria-label="First group"
            >
              <span
                style={{
                  borderRadius: "50%",
                  border: "none",
                  color: "#556ee6",
                  cursor: "pointer",
                }}
                className="btn btn-outline-light"
                onClick={handlePrevClick}
              >
                <i className="fas fa-angle-left"></i>
              </span>
            </div>
          )}
          {totalPages?.length >= 2 && (
            <div
              className="btn-group me-2 "
              role="group"
              aria-label="Second group"
            >
              {map(showOnlyFive, (item, index) => (
                <span
                  key={index}
                  className="btn"
                  onClick={() => handleNumClick(item)}
                  style={{
                    borderRadius: "50%",
                    marginLeft: "5px",
                    marginRight: "5px",
                    border: "none",
                    backgroundColor: apiPage() == item ? "#556ee6" : "transparent",
                    color: apiPage() == item ? "#fff" : "#556ee6",
                    fontWeight: "500",
                    cursor: "pointer",
                  }}
                >
                  {item}
                </span>
              ))}
            </div>
          )}
          {page >= totalPages?.length ? (
            <></>
          ) : (
            <div className="btn-group" role="group" aria-label="Third group">
              <span
                className="btn btn-outline-light"
                style={{
                  borderRadius: "50%",
                  border: "none",
                  color: "#556ee6",
                  cursor: "pointer",
                }}
                onClick={handleNextClick}
              >
                <i className="fas fa-angle-right"></i>
              </span>
            </div>
          )}
        </div>
      </Col>
    </Row>
  )
}

MyPagination.propTypes = {
  totalPages: PropTypes.array,
  page: PropTypes.any,
  setPage: PropTypes.func,
}

export default MyPagination
